import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor() { }


  notifyMe(options: INotificationOption) {
    if (Notification.permission === "granted") {
      let opt = {
        body: options.Body ? options.Body : '',
        icon: options.Icon ? options.Icon : undefined
      }
      const notification = new Notification(options.Title, opt);

      if (options.OnClick)
        notification.addEventListener('click', (e) => { options.OnClick?.() })
      if (options.OnShow)
        notification.addEventListener('show', (e) => { options.OnShow?.() })
    } else {
      this.requestNotificationPermission();
    }

  }
  requestNotificationPermission() {
    if (Notification.permission != "granted") {
      Notification.requestPermission().then(x => console.log("Notification permission", Notification.permission))
    }
  }
}

export interface INotificationOption {
  Title: string;
  Body?: string;
  Icon?: string;
  OnShow?: Function;
  OnClick?: Function;

}
